import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAiReportStore = defineStore('aiReport', () => {
  const generateRequested = ref(false)

  function requestGenerate() {
    generateRequested.value = true
  }

  function clearRequest() {
    generateRequested.value = false
  }

  return { generateRequested, requestGenerate, clearRequest }
})
